const form = {
  formId: "new-company-form",
  formField: {
    logo: {
      name: "logo",
      label: "Logo",
      errorMsg: "Vui lòng chọn ảnh",
    },
    name: {
      name: "name",
      label: "Tên công ty",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tên công ty",
    },
    actionType: {
      name: "actionType",
      label: "Loại hoạt động",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn loại hoạt động",
    },
    members: {
      name: "members",
      label: "Số lượng nhân viên",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số lượng nhân viên",
    },
    email: {
      name: "email",
      label: "Email (Người sở hữu)",
      type: "email",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    phone: {
      name: "phone",
      label: "Số điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    accountNumber: {
      name: "accountNumber",
      label: "Số tài khoản",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số tài khoản",
      invalidMsg: "Số tài khoản không hợp lệ",
    },
    bankOwner: {
      name: "bankOwner",
      label: "Chủ tài khoản",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chủ tài khoản",
      invalidMsg: "Chủ tài khoản không hợp lệ",
    },
    bankBranch: {
      name: "bankBranch",
      label: "Tên chi nhánh ngân hàng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên chi nhánh ngân hàng",
      invalidMsg: "Tên chi nhánh ngân hàng không hợp lệ",
    },
    taxCode: {
      name: "taxCode",
      label: "Mã số thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    introduction: {
      name: "introduction",
      label: "Mô tả",
      type: "text",
      placeholder: "Mô tả về công ty của bạn",
      errorMsg: "Vui lòng nhập mô tả",
    },
    address: {
      name: "address",
      label: "Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
  },
};

export default form;

const createUserForm = {
  formId: "new-user-company-form",
  formField: {
    email: {
      name: "email",
      label: "Email người dùng (user)",
      type: "email",
      placeholder: "soinmedia@gmail.com",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
  },
};

export { createUserForm };
